function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_8_6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5 14.875C15.3337 14.875 16.9538 15.33 18.27 15.925C19.485 16.485 20.25 17.745 20.25 19.11V21H6.75V19.1217C6.75 17.745 7.515 16.485 8.73 15.9367C10.0463 15.33 11.6663 14.875 13.5 14.875ZM4.5 15.1667C5.7375 15.1667 6.75 14.1167 6.75 12.8333C6.75 11.55 5.7375 10.5 4.5 10.5C3.2625 10.5 2.25 11.55 2.25 12.8333C2.25 14.1167 3.2625 15.1667 4.5 15.1667ZM5.77125 16.45C5.355 16.38 4.93875 16.3333 4.5 16.3333C3.38625 16.3333 2.32875 16.5783 1.3725 17.01C0.54 17.3833 0 18.2233 0 19.1683V21H5.0625V19.1217C5.0625 18.1533 5.32125 17.2433 5.77125 16.45ZM22.5 15.1667C23.7375 15.1667 24.75 14.1167 24.75 12.8333C24.75 11.55 23.7375 10.5 22.5 10.5C21.2625 10.5 20.25 11.55 20.25 12.8333C20.25 14.1167 21.2625 15.1667 22.5 15.1667ZM27 19.1683C27 18.2233 26.46 17.3833 25.6275 17.01C24.6713 16.5783 23.6138 16.3333 22.5 16.3333C22.0613 16.3333 21.645 16.38 21.2288 16.45C21.6788 17.2433 21.9375 18.1533 21.9375 19.1217V21H27V19.1683ZM13.5 7C15.3675 7 16.875 8.56333 16.875 10.5C16.875 12.4367 15.3675 14 13.5 14C11.6325 14 10.125 12.4367 10.125 10.5C10.125 8.56333 11.6325 7 13.5 7Z",
  fill: "#F3F3F3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_8_6"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 28,
  fill: "white"
})));

var SvgGroups = function SvgGroups(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroups, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Groups.e0b46c91.svg";
export { ForwardRef as ReactComponent };